import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { FiSupportService } from '@fi-shared/fi-support/fi-support.service';

@Component({
    selector: 'fi-help-menu',
    templateUrl: './help-menu.component.html',
    styleUrls: ['./help-menu.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class HelpMenuComponent {
    @ViewChild('helpMenuTrigger', { static: false }) helpMenuTrigger: MatMenuTrigger;

    constructor(private supportService: FiSupportService) {}

    OpenErrorReport() {
        this.supportService.openFeedbackDialog(false);
    }

    OpenFeedbackForm() {
        this.supportService.openFeedbackDialog(true);
    }

    openHelpMenu() {
        this.helpMenuTrigger.openMenu();
    }
}
